import type {PressReleasePreview} from '@openapi/press-release';
import {previewPressReleaseApi} from '../client';

export const getPressReleaseForExternalPreview = async (
  {
    previewPageKey,
    previewPagePassword,
  }: {
    previewPageKey: string;
    previewPagePassword: string | null;
  },
  init?: RequestInit,
): Promise<PressReleasePreview> => {
  const response = await previewPressReleaseApi.getPressReleaseExternalPreview(
    {
      getPressReleaseExternalPreviewRequest: {
        previewPageKey,
        previewPagePwd: previewPagePassword,
      },
    },
    init,
  );
  return response.data;
};
